"use strict";
var CoverageViewConfig = (function () {
    function CoverageViewConfig() {
    }
    return CoverageViewConfig;
}());
exports.CoverageViewConfig = CoverageViewConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/coverage-view-config.model.js